export default class AnimatedCharacter extends PIXI.Container {
    constructor(name) {
        super();

        this._spine = new PIXI.spine.Spine(P3.assets.spineData(name));
        this._spine.position.set(0, 0);
        this._spine.autoUpdate = false;
        this._spine.skeleton.setSkin(null);
        this._spine.stateData.defaultMix = 0.2;
        this.addChild(this._spine);

        this._spine.state.addListener({
            complete: (entry) => this.onStateComplete(entry),
            event: (entry, event) => this.onStateEvent(entry, event)
        });

        this._isAttacking = false;
        this._isAnimating = true;

        this._idleAnims = [];
        this._attackAnims = [];
        this._damageAnims = [];
        this._defeatAnims = [];
        this._victoryAnims = [];
        this._enterAnims = [];

        this._attackSoundName = "";
        this._damageSoundName = "";
        this._enterSoundName = "";
    }

    init(skin) {
        this.setSkin(skin);
    }

    destroy() {
        super.destroy({children: true});
    }

    update(dt) {
        this._isAnimating && this._spine.update(dt);
    }

    playIdleAnim() {
        if (!this._idleAnims.length) return;
        const name = P3.utils.selectRandom(this._idleAnims);
        this._spine.state.setAnimation(0, name, true);
    }

    playAttackAnim() {
        if (!this._attackAnims.length) return;

        this._isAttacking = true;

        const name = P3.utils.selectRandom(this._attackAnims);
        this._spine.state.setAnimation(0, name, false);
    }

    playDamageAnim() {
        if (!this._damageAnims.length) return;

        this._isAttacking = false;

        const name = P3.utils.selectRandom(this._damageAnims);
        this._spine.state.setAnimation(0, name, false);
    }

    playDefeatAnim() {
        if (!this._defeatAnims.length) return;

        this._isAttacking = false;

        const name = P3.utils.selectRandom(this._defeatAnims);
        this._spine.state.setAnimation(0, name, false);
    }

    playVictoryAnim() {
        if (!this._victoryAnims.length) return;

        this._isAttacking = false;

        const name = P3.utils.selectRandom(this._victoryAnims);
        this._spine.state.setAnimation(0, name, false);
    }

    playEnterAnim() {
        if (!this._enterAnims.length) return;

        this._isAttacking = false;

        const name = P3.utils.selectRandom(this._enterAnims);
        this._spine.state.setAnimation(0, name, false);
    }

    reset() {
        this.playIdleAnim();
        this._spine.update(0);
    }

    setSkin(name) {
        this._spine.skeleton.setSkin(null);
        name && this._spine.skeleton.setSkinByName(name);
    }

    setIdleAnims(arr) {
        this._idleAnims = arr.slice();
    }

    setAttackAnims(arr) {
        this._attackAnims = arr.slice();
    }

    setDamageAnims(arr) {
        this._damageAnims = arr.slice();
    }

    setDefeatAnims(arr) {
        this._defeatAnims = arr.slice();
    }

    setVictoryAnims(arr) {
        this._victoryAnims = arr.slice();
    }

    setEnterAnims(arr) {
        this._enterAnims = arr.slice();
    }

    setEmitterParent(parent) {
        // override
    }

    playAttackSound() {
        if (!this._attackSoundName.length) return;

        P3.audio.playSound(this._attackSoundName);
    }

    playDamageSound() {
        if (!this._damageSoundName.length) return;

        P3.audio.playSound(this._damageSoundName);
    }

    playEnterSound() {
        if (!this._enterSoundName.length) return;

        P3.audio.playSound(this._enterSoundName);
    }

    onStateComplete(entry) {
        const current = this._spine.state.getCurrent(0).animation.name;
        if (this._idleAnims.indexOf(entry.animation.name) !== -1) {
            if (this._idleAnims.indexOf(current) !== -1) {
                this.playIdleAnim();
            }
        } else if (this._defeatAnims.indexOf(entry.animation.name) !== -1) {
            this._isAnimating = false;
        } else {
            this._isAttacking = false;
            this.playIdleAnim();
        }
    }

    onStateEvent(entry, event) {
        switch (event.stringValue) {
            case "sfx_attack" : {
                this.playAttackSound();
                break;
            }
            case "sfx_damage" : {
                this.playDamageSound();
                break;
            }
            case "sfx_enter" : {
                this.playEnterSound();
                break;
            }
        }
    }

    get spine() {
        return this._spine;
    }
}

AnimatedCharacter.ITEM_PURSE = "equip_purse";